import React, { memo } from "react";
import { AsFormItemLayout } from "./AsFormItemLayout";
import type { IFormItemLayout, TInstitutionBeneficiary } from "@adgm/cross-models";
import { KycBeneficiariesTable } from "./KycBeneficiariesTable";
import { KycLabelElement } from "./KycLabelElement";
import { isEqual } from "lodash-es";

interface IProps extends IFormItemLayout<TInstitutionBeneficiary[]> {
  value?: TInstitutionBeneficiary[];
  onChange: (value: TInstitutionBeneficiary[]) => void;
}

/**
 * 自定义比较函数，用于优化memo性能
 * @description 对value数组进行深度比较，其他props使用浅比较
 * @param prevProps - 前一次props
 * @param nextProps - 下一次props
 * @returns boolean - 是否相等
 */
const areEqual = (prevProps: IProps, nextProps: IProps) => {
  return (
    isEqual(prevProps.value, nextProps.value) &&
    prevProps.label === nextProps.label &&
    prevProps.error === nextProps.error &&
    prevProps.sequenceNumber === nextProps.sequenceNumber &&
    prevProps.tip === nextProps.tip &&
    prevProps.hideErrorSpace === nextProps.hideErrorSpace &&
    prevProps.required === nextProps.required &&
    prevProps.style === nextProps.style
  );
};

/**
 * 受益人信息表单组件
 * 用于输入受益人的基本信息
 */
export const BeneficiariesForm: React.FC<IProps> = memo(
  ({
    value = [],
    onChange,
    error,
    label,
    tip,
    hideErrorSpace,
    sequenceNumber,
    style,
    required,
    subLabel,
  }) => {
    return (
      <AsFormItemLayout
        label={label}
        subLabel={subLabel}
        error={error}
        tip={tip}
        hideErrorSpace={hideErrorSpace}
        required={required}
        labelElement={
          <KycLabelElement
            label={label}
            sequenceNumber={sequenceNumber}
            tip={tip}
            required={required}
          />
        }
        style={style}>
        <KycBeneficiariesTable
          value={value}
          onChange={newValue => {
            onChange?.(newValue);
          }}
        />
      </AsFormItemLayout>
    );
  },
  areEqual,
);
